import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CommonModule, NgClass } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LoggerService } from '../../shared/logger.service';
import { EnquiryAddress } from '../../models/models.lib';

@Component({
  selector: 'casi-enquiry-recipient-win',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    FontAwesomeModule
  ],
  templateUrl: './enquiry-recipient-win.html',
  styleUrl: './enquiry-recipient-win.scss'
})
export class EnquiryRecipientWin implements OnInit, OnDestroy {

  public enquiryAddress: EnquiryAddress = new EnquiryAddress();

  @Output() onSubmit: EventEmitter<FormGroup> = new EventEmitter();
  @Output() onClose: EventEmitter<void> = new EventEmitter();

  form: FormGroup;

  private _subs: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private logger: LoggerService,
  ) {
    this.form = this.fb.group(
      {
        id: [null, []],
        address: [null, [Validators.required, Validators.email]],
      }
    );
  }

  get f() {
    return this.form.controls;
  }
  get address() {
    return this.form.get('address');
  }

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    this.form.patchValue(this.enquiryAddress);

    this.address?.valueChanges.subscribe(value => {
      if (value && value !== value.toLowerCase()) {
        this.address?.setValue(value.toLowerCase(), { emitEvent: false });
      }
    });
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnInit...');
    this._subs.forEach(s => s.unsubscribe());
  }

  onSave(): void {
    this.logger.debug(`onSubmit...`, this.form.value);
    const { address } = this.form.value;
    this.onSubmit.emit(this.form);
  }

  closeWindow(): void {
    this.logger.debug(`closeWindow...`);
    this.onClose.emit();

  }

}

